import React from "react";
import { NavLink } from "react-router-dom";
import EducationImage from '../../assest/images/education.png';
import TitleValue from "../../models/dtos/base/TitleValue";
import StaticContentService from "../../services/system/StaticContentService";
import './PanelUpgradeRoute.css';

export default class PanelUpgradeRoute extends React.PureComponent<{},{assistantDetail: TitleValue<string>}> {
  staticContentService: StaticContentService;

  constructor(props: any) {
    super(props);
    this.staticContentService = new StaticContentService()
    this.state = {
        assistantDetail:{
            title:'',
            value:''
        }
    };
  }

  getData(){
    this.staticContentService.getAssistantDetail().then(response => {
        this.setState({
            assistantDetail: response
        })
    })
  }

  componentDidMount(){
      this.getData()
  }

  render() {
    let {assistantDetail} = this.state;
    return (
      <div>
        <div className="col-12 panel-upgrade">
          <div style={{width:'100%'}}>
            <img src={EducationImage} width="180" height="180" alt="" />
            <label style={{display: 'block'}}>
              جهت استفاده از خدمات ویژه با شماره همراه زیر تماس حاصل کنید
            </label>
            <label style={{display:'block'}}>
              کارشناس : {assistantDetail.title}
            </label>
            <div className="area-label">
              <label
                className="mdi mdi-phone"
              ></label>
              <a style={{display: 'block'}} href={`tel:${assistantDetail.value}`}>
                {assistantDetail.value}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
